import type { DateRowItem } from "@models/Schedule";

const DAY_CELL_WIDTH = 42;

/**
 * Scrolls a horizontally-scrolling container so that today's column is centered.
 * If today is not in `monthDateList`, does nothing. The browser clamps overflow,
 * so months where today is near the edge will naturally end up scrolled as far
 * as possible toward (but not past) the start/end.
 */
export function scrollToToday(container: HTMLElement, monthDateList: DateRowItem[]): void {
	const todayIndex = monthDateList.findIndex((d) => d.isToday);
	if (todayIndex < 0) return;

	const target = todayIndex * DAY_CELL_WIDTH + DAY_CELL_WIDTH / 2;
	container.scrollLeft = target - container.clientWidth / 2;
}
